import { ProjectEstimate } from "@app/shared/models";

export interface IEstimateTab {
  TabTitle?: string;
  TabSelected?: boolean;
  TabDisabled?: boolean;
  Status?: string;
  ProjectEstimateId?: number;
  ProjectId?: number;
  EstimateVersion?: number;
  RecordStatus?: string | null;
  RecordTypeId?: number | null;
  CreatedByEmployeeId?: number | null;
  ProjectEstimate: ProjectEstimate
}

export class EstimateTab implements IEstimateTab {
  constructor(private projectEstimate: ProjectEstimate, private title: string, private tabselected: boolean, private tabdisabled: boolean) {

  }
  public get TabTitle(): string { return this.title };
  public get TabSelected(): boolean { return this.tabselected };
  public get TabDisabled(): boolean { return this.tabdisabled };
  public get Status(): string { return this.ProjectEstimate.ProjectEstimateStatus.Description; }
  public get ProjectEstimateId(): number { return this.ProjectEstimate.ProjectEstimateId; }
  public get ProjectId(): number { return this.ProjectEstimate.ProjectId; };
  public get EstimateVersion(): number { return this.ProjectEstimate.EstimateVersion; }
  public get RecordStatus(): string { return this.ProjectEstimate.RecordStatus };
  public get RecordTypeId(): number { return this.ProjectEstimate.RecordTypeId; }
  public get CreatedByEmployeeId(): number { return this.ProjectEstimate.CreatorId };
  public get ProjectEstimate(): ProjectEstimate { return this.projectEstimate };
  public set ProjectEstimate(val: ProjectEstimate) {
    this.projectEstimate = val;
  }
}